<template>
  <div class="tabs">
    <button
      class="btn add-btn"
      @click="addToBetslip"
      :class="{ 'flash': isValid  }">
      <i class="n-i n-i-betslip-options" />

      {{ bettingSvc.updateBet ? 'update_bet' : 'add_bet' | translate }}
    </button>
    <button
      class="btn clear-btn"
      @click="clearBetting">
      <span class="n-i n-i-trash" />
    </button>
    <div class="tabs-list">
      <div
        v-for="(tab,index) in tabs"
        :key="index">
        <div
          @click="selectTab(tab)"
          :ref="tab.name"
          class="tab"
          :class="{ 'is--active': tab.isActive }">
          <div class="tabs-title">{{ tab.name | translate }}</div>
        </div>
      </div>
    </div>
    <div class="tabs-details">
      <slot />
    </div>
  </div>
</template>

<script>
import { translate } from '../../filters/translate';
import { EventBus } from "../../utilities/event.bus";
import { GatewaySvc } from '../../services/gateway.service';
import { BettingSvc } from "../../services/betting.service";
import { GameSvc } from "../../services/game.service";
import {TicketSvc}  from '../../services/ticket.service';
import { PaytableSvc } from "../../services/paytable.service";
import { TranslationSvc } from '../../services/translation.service';

export default {
  name: "Tabs",

  filters: {
    translate,
  },

  data() {
    return {
      tabs: [],
      bettingSvc: BettingSvc.getBettingSvc(),
      paytableSvc: PaytableSvc.getPaytableSvc(),
      gatewaySvc: GatewaySvc.getGatewaySvc(),
      gameSvc: GameSvc.getGameSvc()
    };
  },

  created() {
    this.tabs = this.$children;

    EventBus.$on("Keno.SwitchBettings", (bettingType) => {
      this.selectTab(this.tabs[bettingType === 'normal' ? 0 : 1])
    });
  },

  computed: {
    isValid() {
      let numbers,
        isValid = false;



      if (this.bettingSvc.type === "system") {
        numbers = this.paytableSvc.paytable[
          this.bettingSvc.system + "_" + this.bettingSvc.ticket.input.length
        ];
      } else if (this.bettingSvc.type === 'normal') {
        numbers =
          this.gameSvc.spotNumber >= this.bettingSvc.ticket.input.length &&
          this.paytableSvc.paytable[
            this.bettingSvc.ticket.input.length +
            "_" +
            this.bettingSvc.ticket.input.length
          ];
      } else if (this.bettingSvc.type === 'special') {
        numbers = 1;

        if (this.bettingSvc.specialBetsActiveStatus[41]) {
          if (this.bettingSvc.ticket.input.length > sevenConfig.data.config.rules.maxAllInNumbers.value) {
            numbers = 0;
          }
        }

        if (this.bettingSvc.specialBetsActiveStatus[40]) {
          if (this.bettingSvc.ticket.input.length > sevenConfig.data.config.rules.maxNoDrawNumbers.value) {
            numbers = 0;
          }
        }

        if (this.bettingSvc.specialBetType == 40 || this.bettingSvc.specialBetType == 41) {
          if (this.bettingSvc.ticket.input && !this.bettingSvc.ticket.input.length) {
            numbers = 0;
          }
        }
      }

      if (numbers) {
        isValid = true;
      }

      return isValid;
    }
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name;
      });
    },

    addToBetslip() {
      const maxBetNumber = sevenConfig.data.config.rules.maxBetNumber.value;
      const ticket = TicketSvc.getTicketSvc().ticket;
      const totalBetsAdded = ticket.bets ? ticket.bets.length : 0;

      if (totalBetsAdded >= maxBetNumber) {
        this.gatewaySvc.showDialog({
          message: TranslationSvc.getTranslation('max_bet_number', maxBetNumber)
        });
        return;
      }

      for (let i in this.bettingSvc.specialBetsActiveStatus) {
        if (this.bettingSvc.specialBetsActiveStatus[i]) {
          this.bettingSvc.terminalSpecialBet({target: { id: i } }, this.bettingSvc);
        }
      }

      if ((this.bettingSvc.ticket.input.length || this.bettingSvc.ticket.input) && this.isValid) {
        EventBus.$emit("Keno.AddToBetslip");
      } else {
        this.gatewaySvc.showDialog({
          message: this.bettingSvc.ticket.input.length ?
            TranslationSvc.getTranslation('bet_not_valid') : TranslationSvc.getTranslation('select_bet')
        });
      }
    },

    clearBetting() {
      EventBus.$emit("Keno.ClearBetting");
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/style/helpers";

.tabs {
  background-color: #171717;
  margin-top: 10px;

  .tabs-title {
    color: #fff;
  }

  .add-btn {
    color: #fff;
    background-color: #3a7c40;
    float: right;
  }

  .clear-btn {
    color: #e6e6e6;
    background-color: #323232;
    float: right;
    margin-right: 5px;
  }
}

.tabs-list {
  background-color: #171717;
  position: relative;

  &:before {
    background: #0066ae;
    content: " ";
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 1px;
  }
}

.tab {
  float: left;
  position: relative;
  padding: 1.2rem 2rem;
  z-index: 2;
  cursor: pointer;

  &.is--active {
    background-color: #242424;
  }
}
</style>



// WEBPACK FOOTER //
// Tabs.vue?9fa35cea